module.exports = __webpack_public_path__ + "static/media/remember_2.093d4f6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/remember_2.svg
// module id = 606
// module chunks = 0